var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z",
    fill: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "nonzero",
    d: "M15.86 4.04H3.52A1.51 1.51 0 0 0 2 5.51l-2 9.17c0 .834.676 1.51 1.51 1.51h16.35a1.51 1.51 0 0 0 1.51-1.51l-2-9.17a1.51 1.51 0 0 0-1.51-1.47zm-2 8.73l-1-.86 1.05-1.12H5.48l1.05 1.09-1 .86-2.42-2.64 2.43-2.63 1 .86-1.06 1.11h8.43l-1.06-1.12 1-.86 2.44 2.63-2.43 2.68z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandSize);
export default __webpack_public_path__ + "static/media/landSize.5184afdf030daca77292effe536823f9.svg";
export { ForwardRef as ReactComponent };